"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SelectIcon = function (props) {
    return (react_1.default.createElement("svg", __assign({ width: '24', height: '24', viewBox: "0 0 24 24" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M18.307 5L20 6.277l-9.21 12.226L5 14.155l1.276-1.694 4.103 3.125z" })));
};
exports.default = SelectIcon;
